/* eslint-disable @typescript-eslint/no-explicit-any */
export const createPromiseResolver = () => {
	let resolve: () => void;

	const promise = new Promise<void>(r => {
		resolve = r;
	});
	// we are overriding the resolve! here because the new Promise will definitely assign it
	return { resolve: resolve!, promise };
};

export let win: { [name: string]: any };

if (typeof window !== 'undefined') {
	win = window;
} else if (typeof global !== 'undefined') {
	win = global;
} else if (typeof self !== 'undefined') {
	win = self;
} else {
	win = {};
}

// TODO: For better type safety, the manifest shape for each plugin should be strongly typed and thus
// the name argument becomes a sub-key of this manifest collection and the return type becomes a mapped
// type of the manifest shape keyed on the given name
export function getManifest(name?: string): any {
	const n = name ?? 'fox-seeourm';
	const manifestList =
		typeof window !== 'undefined' && Array.isArray((window as any)['manifest']) ? ((window as any)['manifest'] as Array<{ name: string }>) : [];
	const manifest = manifestList.find(m => m.name === n);
	return manifest ?? {};
}

export const SERVICE_ENDPOINTS_MANIFEST_NAME = 'swiftfox-endpoints';

export type ServiceEndpointName =
	| 'ApiGateway'
	| 'Campaigns'
	| 'Canvas'
	| 'Core'
	| 'Dashboard'
	| 'Festival'
	| 'Financial'
	| 'Forms'
	| 'FoxFeed'
	| 'Gov'
	| 'IdentityAdmin'
	| 'Integrations'
	| 'Lists'
	| 'Map'
	| 'Postie'
	| 'Reporting'
	| 'Settings'
	| 'Super'
	| 'SurveyFrontend'
	| 'User';

type ServiceEndpointsManifest = {
	endpoints?: Partial<Record<ServiceEndpointName | `${ServiceEndpointName}WebSocket`, string>>;
};

export function resolveServiceEndpoint(
	manifest: ServiceEndpointsManifest | undefined,
	name: ServiceEndpointName,
	fallback?: string
) {
	const endpoint = manifest?.endpoints?.[name];
	return typeof endpoint === 'string' && endpoint.length > 0 ? endpoint : fallback;
}

export function getServiceEndpoint(name: ServiceEndpointName, fallback?: string) {
	return resolveServiceEndpoint(getManifest(SERVICE_ENDPOINTS_MANIFEST_NAME), name, fallback);
}

export function getMapBaseEndpoint() {
	const endpoint = getManifest('fox-gov-map').options?.mapBaseEndpoint;
	return getServiceEndpoint('Map', typeof endpoint === 'string' ? endpoint : undefined);
}

export function resolveWebSocketServiceEndpoint(
	manifest: ServiceEndpointsManifest | undefined,
	name: ServiceEndpointName,
	fallback?: string
) {
	const explicitEndpoint = manifest?.endpoints?.[`${name}WebSocket`];
	if (typeof explicitEndpoint === 'string' && explicitEndpoint.length > 0) {
		return explicitEndpoint;
	}

	const endpoint = resolveServiceEndpoint(manifest, name);
	if (!endpoint) {
		return fallback;
	}

	try {
		const url = new URL(endpoint);
		if (url.protocol === 'ws:' || url.protocol === 'wss:') {
			return endpoint;
		}
		if (url.protocol !== 'http:' && url.protocol !== 'https:') {
			return fallback ?? endpoint;
		}

		url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
		return url.toString();
	} catch {
		return fallback ?? endpoint;
	}
}

export function getWebSocketServiceEndpoint(name: ServiceEndpointName, fallback?: string) {
	return resolveWebSocketServiceEndpoint(getManifest(SERVICE_ENDPOINTS_MANIFEST_NAME), name, fallback);
}
